import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${themeGet('spacing.2xl')};
  padding-bottom: ${themeGet('spacing.2xl')};
`;
